import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Edit from '@material-ui/icons/Edit'
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";

export default class Engineers extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns=[
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={`/engineers/${props.original.pkey}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Freshdesk Ticket",
				id: "fresh_ticket",
				/** @param {Tickets_Object} props.original */
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
			},
			{
				Header: "Date Created",
				id: 'created',
				/** @param {Tickets_Object} obj */
				accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
			},
			{
				Header: "Assigned To",
				id: 'field_engineer',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.assigned ? (obj.field_engineers.name_first + ' ' + obj.field_engineers.name_last) : '',
			},
			{
				Header: "Appointment Start",
				id: 'appointment_start',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.appointment_start ? moment(obj.appointment_start).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Customer",
				id: 'customer',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.customers ? obj.customers.name : '',
				Cell: (props) => {
					let {original} = props;
					let {customers} = original;

					if (!customers) return null;

					return (
						<span>
							<Link to={`/customers/${customers.pkey}`}>
								{customers.name}
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Tickets')}
							{this.renderHeaderRight("Tickets",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
